module.exports = {"TXTMOB_Resend_code_in_N0":{"id":"TXTMOB_Resend_code_in_N0","defaultMessage":"Send kode igen om {0}","track":"Resend code in {0}"}}